import React from "react";
import "./App.less";

import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";

import Login from "./pages/Auth/Login";
import MainLayout from "./MainLayout";
import config from "./config/config";
import { jwtDecode } from "jwt-decode";
import Logout from "./components/Logout";
import { ConfigProvider } from "antd";
function App() {
  React.useEffect(() => {
    const updateActivity = () => {
      localStorage.setItem("last_activity", Date.now().toString());
    };

    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keydown", updateActivity);
    window.addEventListener("scroll", updateActivity);
    window.addEventListener("click", updateActivity);

    // Initial activity set if not exists
    if (!localStorage.getItem("last_activity")) {
      updateActivity();
    }

    return () => {
      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keydown", updateActivity);
      window.removeEventListener("scroll", updateActivity);
      window.removeEventListener("click", updateActivity);
    };
  }, []);

  const PrivateRoute = ({ children, guard = null }) => {
    let user;
    const token = localStorage.getItem(config.jwt_store_key);
    const lastActivity = localStorage.getItem("last_activity");

    // Check for inactivity timeout (2 hours)
    if (token && lastActivity) {
      const inactiveDuration = Date.now() - parseInt(lastActivity);
      const timeoutThreshold = 2 * 60 * 60 * 1000; // 2 hours in ms
      
      if (inactiveDuration > timeoutThreshold) {
        console.log("Session expired due to inactivity");
        localStorage.removeItem(config.jwt_store_key);
        localStorage.removeItem("last_activity");
        return <Navigate to="/login" />;
      }
    }

    if (token) {
      try {
        user = jwtDecode(token);
        
        // Check for JWT expiration
        const currentTime = Date.now() / 1000;
        if (user.exp && user.exp < currentTime) {
          console.log("Token expired");
          localStorage.removeItem(config.jwt_store_key);
          user = null;
        }
      } catch (error) {
        console.log({ error });
        localStorage.removeItem(config.jwt_store_key);
      }
    }

    if (!user) {
      // user is not authenticated or token expired
      return <Navigate to="/login" />;
    }
    return children;
  };


  

  return (
    <ConfigProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          <Route
            path="/*"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
